import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { InboxDetailsPageRoutingModule } from './inbox-details-routing.module';
import { InboxDetailsPage } from './inbox-details.page';
import { PipeSharedModule } from '@pipes/pipe-shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    InboxDetailsPageRoutingModule,
    PipeSharedModule,
    TranslateModule
  ],
  declarations: [InboxDetailsPage]
})
export class InboxDetailsPageModule {}
